








































import { defineComponent } from "@vue/composition-api";
import { BlockLabel } from "@/models/BlockLabel";
import { Expandable, TextField } from "@/components";
import { AssociationSelect } from "@/components";
import { Federation } from "@/models/Federation";
import { getFederationNameByNumber } from "@/utils/federation-name";

export default defineComponent({
  name: "SharedInvoice",
  components: {
    Expandable,
    TextField,
    AssociationSelect,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
  },
  data() {
    return {
      otherAssociationName: "NHO",
      otherAssociationNhoNumber: 60001,
      otherAssociationPercent: 50,
      displayName: BlockLabel.SharedInvoice,
    };
  },
  computed: {
    associations(): Array<Federation> {
      return this.$store.getters.associations;
    },
  },
  mounted() {
    if (this.data) {
      this.otherAssociationNhoNumber = this.data.otherAssociationNhoNumber;
      this.otherAssociationPercent = this.data.otherAssociationPercent;
      // The name is no longer stored on the block (FederationHub is master),
      // so resolve it from the number for the association select.
      this.otherAssociationName =
        this.data.otherAssociationName ??
        getFederationNameByNumber(
          this.associations,
          this.otherAssociationNhoNumber
        );
    }
  },
  methods: {
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.otherAssociationNhoNumber = this.getNumberFromName(
        this.otherAssociationName
      );
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        otherAssociationName: this.otherAssociationName,
        otherAssociationNhoNumber: this.otherAssociationNhoNumber,
        otherAssociationPercent: this.otherAssociationPercent,
      });
    },
    getNumberFromName(assocationName: string): number {
      const item = this.associations?.find(
        (org: Federation) => org.name === assocationName
      );
      return item?.nhoNumber ?? 0;
    },
    getAssociationShareText(): string {
      const name = getFederationNameByNumber(
        this.associations,
        this.otherAssociationNhoNumber
      );
      return `av totalen går til ${name} (${this.otherAssociationNhoNumber})`;
    },
  },
});
